import { TableHeader, TableRow, TableHead } from "../ui/table";
import { Checkbox } from "../ui/checkbox";
import type { TableColumn, ValidTableNames } from "@/hooks/table/types";
import { ReactNode } from "react";
import { useCommonI18n } from "@/hooks/useModuleI18n";

interface DataTableHeaderProps<T extends ValidTableNames = any> {
  displayColumns: TableColumn<T>[];
  enableRowSelection?: boolean;
  allRowsSelected: boolean;
  handleSelectAll: () => void;
  handleColumnHeaderClick: (columnKey: string, e: React.MouseEvent) => void;
  getSortIcon: (columnKey: string) => ReactNode;
  hasActions: boolean;
}

export default function DataTableHeader<T extends ValidTableNames = any>({
  displayColumns,
  enableRowSelection,
  allRowsSelected,
  handleSelectAll,
  handleColumnHeaderClick,
  getSortIcon,
  hasActions,
}: DataTableHeaderProps<T>) {
  const { t } = useCommonI18n();
  return (
    <TableHeader className="rounded-t-lg">
      <TableRow>
        {enableRowSelection && (
          <TableHead className="w-12! p-0!">
            <div className="flex items-center justify-center h-full w-full">
              <Checkbox
                checked={allRowsSelected}
                onCheckedChange={handleSelectAll}
                aria-label={t("table.selection.selectAllRows")}
              />
            </div>
          </TableHead>
        )}
        {displayColumns.map((column) => (
          <TableHead
            key={column.key as string}
            className={`text-gray-500 dark:text-gray-500 text-xs ${column.className} ${
              column.sortable
                ? "cursor-pointer hover:text-gray-700 dark:hover:text-gray-100 transition-colors"
                : ""
            }`}
            onClick={(e) =>
              column.sortable &&
              handleColumnHeaderClick(column.key as string, e)
            }
          >
            <div
              className={`flex items-center gap-2 select-none ${
                column.className?.includes("justify-end") ? "justify-end" : ""
              }`}
            >
              <span>{column.label}</span>
              {column.sortable && getSortIcon(column.key as string)}
            </div>
          </TableHead>
        ))}
        {hasActions && (
          <TableHead className="text-center font-regular  sticky right-0 z-20 bg-background">
            <span className="sr-only">Acciones</span>
          </TableHead>
        )}
      </TableRow>
    </TableHeader>
  );
}
